<!--========================
=            C3            =
=========================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">C3 Charts</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
       
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card class="pa-2 pr-2">
          <div slot="card-header">Time Gradient</div> <div slot="card-subheader">Dolor nulla ullamco consequat aliquip officia pariatur culpa ex deserunt magna.</div>
          <div slot="card-body">
            <div style="height:10px!important"></div>
            <div id="combine-chart"></div>
          </div>
        </base-card>
      </v-col>
     <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Sessions Device</div>
               <div slot="card-subheader">Dolor nulla ullamco consequat aliquip officia pariatur culpa ex deserunt magna.</div>
          <div slot="card-body">
            <div id="chart"></div>
          </div>
        </base-card>
      </v-col>
       

      </template>
    </v-row>
     <v-row>
      <template>
       
             <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Browser Used By Users</div><div slot="card-subheader">Dolor nulla ullamco consequat aliquip officia pariatur culpa ex deserunt magna.</div>
          <div slot="card-body">
            <div id="donut-chart"></div>
          </div>
        </base-card>
      </v-col>
    
       <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header"> Users</div><div slot="card-subheader">Dolor nulla ullamco consequat aliquip officia pariatur culpa ex deserunt magna.</div>
          <div slot="card-body">
            <div id="pie-chart"></div>
          </div>
        </base-card>
      </v-col>
       

      </template>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },  mounted() {
      var ChartC3 = function () {};

      (ChartC3.prototype.init = function () {
        //generating chart
        c3.generate({
          bindto: "#chart",
          data: {
            columns: [
              ["data1", 30, 20, 50, 40, 60, 50],
              ["data2", 200, 130, 90, 240, 130, 220],
              ["data3", 300, 200, 160, 400, 250, 250]
            ],
            type: "bar",
            colors: {
              data1: "#dcdcdc",
              data2: "#66b2b2",
              data3: "#b266b2"
            }
          }
        });

        //combined chart
        c3.generate({
          bindto: "#combine-chart",
          data: {
            columns: [
              ["data1", 30, 20, 50, 40, 60, 50],
              ["data2", 200, 130, 90, 240, 130, 220],
              ["data3", 300, 200, 160, 400, 250, 250],
              ["data4", 200, 130, 90, 240, 130, 220],
              ["data5", 130, 120, 150, 140, 160, 150]
            ],
            types: {
              data1: "bar",
              data2: "bar",
              data3: "spline",
              data4: "line",
              data5: "bar"
            },
            colors: {
              data1: "#dcdcdc",
              data2: "#66b2b2",
              data3: "#36404a",
              data4: "#fb6d9d",
              data5: "#b266b2"
            },
            groups: [
              ["data1", "data2"]
            ]
          },
          axis: {
            x: {
              type: "categorized"
            }
          }
        });

     
        //Donut Chart
        c3.generate({
          bindto: "#donut-chart",
          data: {
            columns: [
              ["data1", 46],
              ["data2", 24],
              ["data3", 30]
            ],
            type: "donut"
          },
          donut: {
            title: "Dogs love:",
            width: 15,
            label: {
              show: false
            }
          },
          color: {
            pattern: ["#f4f8fb", "#66b2b2", "#b266b2"]
          }
        });

        //Pie Chart
        c3.generate({
          bindto: "#pie-chart",
          data: {
            columns: [
              ["Lulu", 46],
              ["Olaf", 24],
              ["Item 3", 30]
            ],
            type: "pie"
          },
          color: {
            pattern: ["#f4f8fb", "#66b2b2", "#b266b2"]
          },
          pie: {
            label: {
              show: false
            }
          }
        });

       

        //Scatter Plot
       
      }),
      ($.ChartC3 = new ChartC3()),
      ($.ChartC3.Constructor = ChartC3);

      $.ChartC3.init();
    }
    
  }
</script>


<!--====  End of C3  ====-->
